module.exports = __webpack_public_path__ + "static/img/righty.5cd40b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/car/righty.png
// module id = k9ge
// module chunks = 37